import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, EventEmitter, Output, TemplateRef } from '@angular/core';
import { CommonService } from '../../../shared/providers/common.service';
import { ExternalMarketingListComponent } from '../external-marketing-list/external-marketing-list.component';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

export enum Timeline {
    BOV = 1,
    Premarketing = 2,
    Marketing = 3,
    DealMaking = 4,
    Closed = 5
}

@Component({
    selector: 'app-prospects',
    templateUrl: './prospects.component.html',
    styleUrls: ['./prospects.component.css']
})
export class ProspectsComponent implements OnInit {

    @Input() propertyId: number;
    @Input() IsPortfolio: boolean;
    @Input() property: any;
    @Input() isFromDashboard: boolean;
    @Input() isFromPortfolio: boolean = false;
    @Output() loadProspect = new EventEmitter();
    @Input() propsectMennuId: number;
    externalMarketingTypeList: any[];
    externalMarketingTypeListForProperties: any[];
    menuId: number;
    showExternalMArketingList = false as boolean;
    @ViewChild(ExternalMarketingListComponent) externalMarketingChild: ExternalMarketingListComponent;
    externalMarketingType: any;
    prospectTabVisibility = false as boolean;
    showNodata = false as boolean;
    selectedTimelineId: number;
    timeline = Timeline;
    showPlusView = false;

    constructor(private _commonService: CommonService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _dashboardService: DashboardService,
        public _authenticationService: AuthenticationService,
        private loader: LoaderService,
        private modalService: BsModalService,
        public Validation: ValidationService,
        private Toast: ToastService
    ) { }

    currentSFid = '';
    ngOnInit() {
        this.selectedTimelineId = this.property.PropertyStatus == 'BOV' ? this.timeline.BOV : (this.property.PropertyStatus == 'Pre-Marketing' ? this.timeline.Premarketing :
            (this.property.PropertyStatus == 'Available' || this.property.PropertyStatus == 'Not Available' ||
                this.property.PropertyStatus == 'Off-Market' ? this.timeline.Marketing :
                (this.property.PropertyStatus == 'Sold' ? this.timeline.Closed : this.timeline.DealMaking)));
        this.showNodata = this.selectedTimelineId >= this.timeline.Marketing ? false : true;

        this.loader.display(true);
        let user = this._authenticationService.user as any;
        let menuId = 0;
        menuId = this.isFromDashboard ? -1 : (this.propsectMennuId != null && this.propsectMennuId > -1 ? this.propsectMennuId : 0);
        this.loadCount();
        if (this.property.IsPortfolio) {
            this.loadPortfolioPropertyCount();
        }
        this.prospectTabVisibility = this.property.SellerId.includes(user.Id);
        this._changeDetectorRef.detectChanges();
        this.menuId = menuId;
    }

  loadCount() {
    this._dashboardService.getExternalMarketingCount(this.property.Id).subscribe(res => {
            this.externalMarketingTypeList = res.map(o => {
                return {
                    id: o.Id, description: o.Description, count: o.Count
                };

            });
            if (this.menuId > 0) {
                let item = this.externalMarketingTypeList.filter(x => x.id == this.menuId)[0];
                this.loadExternalMarketingType(item);
            }
            this.loader.display(false);
        })
    }

    loadPortfolioPropertyCount() {
        this._dashboardService.getExternalMarketingCountForPortfolio(this.propertyId).subscribe(res => {
            this.externalMarketingTypeListForProperties = res.map(o => {
                return {
                    id: o.Id, description: o.Description, count: o.Count
                };

            });
            if (this.menuId > 0) {
                let item = this.externalMarketingTypeListForProperties.filter(x => x.id == this.menuId)[0];
                this.loadExternalMarketingType(item);
            }
            this.loader.display(false);
        })
    }

    loadExternalMarketingType(type) {
        if (this.isFromDashboard) {
            this.loadProspect.emit(type);
        }
        else {
            this.showExternalMArketingList = false;
            this.menuId = type.id;
            if (type.id == 0) {
                this.loadProspects();
            }
            else {
                try {
                    this.externalMarketingType = type;
                    if (type.id == 4052 || type.id == 4053) {// Calls and Emails
                        this.externalMarketingChild.hideSource = true;
                    }
                    else {
                        this.externalMarketingChild.hideSource = false;
                    }
                    this.externalMarketingChild.dtElement.dtInstance.then(x => x.order([1, "desc"]).draw(false));
                }
                catch (ex) {
                }
                this.showExternalMArketingList = true;
                this._changeDetectorRef.detectChanges();
            }
        }


    }

    update(event) {
        //this.externalMarketingTypeList.forEach(item => {
        //    if (item.id == event.id) {
        //        item.count = event.count
        //    }
        //});
        this.loadCount();
        if (this.property.IsPortfolio) {
            this.loadPortfolioPropertyCount();
        }
    }

    loadProspects() {
        this.menuId = 0;
    }
    modalRef: BsModalRef;
    openModalForSF(template: TemplateRef<any>, classes: any) {
        this.isSubmit = false;
        this.currentSFid = this.property.SFId;
        this.modalRef = this.modalService.show(template, { class: classes });
    }
    isSubmit = false;
    mapSFId() {
        this.loader.display(true);
        this._dashboardService.UpdateSalesforceId(this.property.Id, this.currentSFid).subscribe(res => {
            this.property.SFLink = res;
            this.property.SFId = this.currentSFid;
            this.modalRef.hide();
            this.Toast.addToast({ title: 'Success', msg: 'Salesforce mapping saved Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            this.loader.display(false);
        })
    }

    modalRefLinking: BsModalRef;
    openModalForLinking(template: TemplateRef<any>, classes: any, ProspectId, PropertyId) {
        this.modalRefLinking = this.modalService.show(template, { class: classes });
    }
}
